import { z } from "zod/v4";

export const moderationCategorySchema = z.enum([
	"spam",
	"sexual",
	"harassment",
	"hate",
	"violence",
	"self_harm",
]);
export type ModerationCategory = z.infer<typeof moderationCategorySchema>;

export const categoryScoresSchema = z.object({
	spam: z.number(),
	sexual: z.number(),
	harassment: z.number(),
	hate: z.number(),
	violence: z.number(),
	self_harm: z.number(),
});
export type CategoryScores = z.infer<typeof categoryScoresSchema>;

export const contentModerationStatusSchema = z.enum([
	"pending",
	"auto_hidden",
	"dismissed",
	"actioned",
]);
export type ContentModerationStatus = z.infer<typeof contentModerationStatusSchema>;

export const contentModerationSchema = z.object({
	id: z.string(),
	content_type: z.enum(["profile", "chat_message", "game"]),
	content_id: z.string(),
	service: z.string(),
	author_id: z.string().nullable().optional(),
	text_excerpt: z.string().nullable().optional(),
	image_urls: z.array(z.string()),
	ai_model: z.string(),
	scores: categoryScoresSchema,
	max_category: moderationCategorySchema,
	max_score: z.number(),
	verdict: z.enum(["review", "block"]),
	reason: z.string().nullable().optional(),
	status: contentModerationStatusSchema,
	created_at: z.string(),
});
export type ContentModerationItem = z.infer<typeof contentModerationSchema>;
